import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {TramiteFirmasElectronicasService} from "../services/tramiteFirmasElectronicas.service";
import {lastValueFrom} from "rxjs";

export const hasFirmaGuard: CanActivateFn = async (route, state) => {

  const _tfes = inject(TramiteFirmasElectronicasService);
  const router = inject(Router);
  const solicitud = router.getCurrentNavigation()?.extras.state?.['data'];
  if (!solicitud) router.navigate(['/tramites']);
  const response = await lastValueFrom(_tfes.validaFirma(solicitud)).then();
  if (!response) {
    router.navigate(['/tramites']);
    return false;
  }
  return true;


};
